export default __webpack_public_path__ + "static/media/Amazon-Prime.c8cc393a.png";